import React from "react";
import IosShareSvg from "assets/icons/ios-share.svg?react";

function IOSinstructions() {
  return (
    <div>
      <h2>برای نصب در سیستم عامل ای او اس می توانید:</h2>
      <ol>
        <li>
          ۱. در نوار پایین روی دکمه‌ی <IosShareSvg /> کلیک کنید.
        </li>
        <li>
          ۲. سپس در منویی که باز می‌شود، گزینه‌ی "Add to home screen" را انتخاب
          کنید
        </li>
        <li>۳. در مرحله‌ی بعد روی Add کنید.</li>
      </ol>
    </div>
  );
}

export default IOSinstructions;
